module.exports = __webpack_public_path__ + "img/add-tag.cd71e9fa.svg";